import outputs from './amplify_outputs.json';

// Cognito is not managed by Amplify's Gen 2 tooling (it was already an
// "imported" resource under Gen 1), so it isn't part of amplify_outputs.json.
// These values are carried over as-is from the previous aws-exports.js.
//
// Redirect URIs are derived from the actual browser origin (not hardcoded
// per-environment) so this works on localhost, the production custom domain,
// and any Amplify-generated preview/branch domain alike. Each origin used
// here must also be registered in the Cognito app client's allowed
// callback/logout URLs, or the Hosted UI will reject the redirect.
const redirectSignIn = [`${window.location.origin}/transactions/`];
const redirectSignOut = [`${window.location.origin}/`];

export const amplifyConfig = {
  ...outputs,
  auth: {
    user_pool_id: 'us-east-2_HBS8HX9eF',
    aws_region: 'us-east-2',
    user_pool_client_id: 'mhfhpja7d56f3bbr138mabudl',
    identity_pool_id: 'us-east-2:c68c5e19-4d37-456c-924d-fa4ac54e9693',
    oauth: {
      domain: 'qboidapp.auth.us-east-2.amazoncognito.com',
      scopes: ['openid', 'email', 'phone'],
      redirect_sign_in_uri: redirectSignIn,
      redirect_sign_out_uri: redirectSignOut,
      response_type: 'token',
    },
  },
};
